{
  "register-personal-data-page": {
    "buttons": {
      "next": "Suivant",
      "to-login": "Pour se connecter"
    },
    "text": {
      "title": "Inscription",
      "subtitle": "Enregistrez votre nouveau compte",
      "have-account-question": "Vous avez déjà un compte ?",
      "personal-info": "Vos informations personnelles",
      "personal-info-hint": "Veuillez saisir vos coordonnées ci-dessous"
    }
  }
}
